import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IOperatorTail } from 'src/models/operator-tail.model';
import services from 'src/services/operator-tail.service';

export const actionTypes = {
  OPERATOR_TAIL_NUMBER_FETCH: 'OPERATOR_TAIL_NUMBER_FETCH',
  OPERATOR_TAIL_NUMBER_ADD: 'OPERATOR_TAIL_NUMBER_ADD',
  OPERATOR_TAIL_NUMBER_UPDATE: 'OPERATOR_TAIL_NUMBER_UPDATE',
  OPERATOR_TAIL_NUMBER_DELETE: 'OPERATOR_TAIL_NUMBER_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.OPERATOR_TAIL_NUMBER_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.OPERATOR_TAIL_NUMBER_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.OPERATOR_TAIL_NUMBER_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.OPERATOR_TAIL_NUMBER_DELETE,
    service: services.itemDELETE,
  },
};

export type IOperatorTailAsync = typeof asyncActions;

export interface IOperatorTailState extends ICommonState<IOperatorTailAsync> {
  data?: IOperatorTail;
  list: IOperatorTail[];
  total: number;
}

export const defaultState: IOperatorTailState = {
  status: {},
  list: [],
  total: 0,
};

const OperatorTailReducer = (
  state: IOperatorTailState = defaultState,
  action: IReducerAction<IOperatorTailAsync>
): IOperatorTailState => {
  switch (action.type) {
    case actionTypes.OPERATOR_TAIL_NUMBER_FETCH: {
      return {
        ...state,
        list: action.payload?.rows ?? [],
        total: action.payload?.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default OperatorTailReducer;
